import { Box, Image, Theme } from "@outschool/backpack";
// No need to translate company names
/* eslint-disable i18next/no-literal-string */
import { ExternalLink } from "@outschool/ui-components-shared";
import React from "react";

import CBSLogo from "../images/press-logos/cbs@2x.png";
import FastCompanyLogo from "../images/press-logos/fastcompany@2x.png";
import ForbesLogo from "../images/press-logos/forbes@2x.png";
import NPRLogo from "../images/press-logos/npr@2x.png";
import NYTLogo from "../images/press-logos/nyt@2x.png";
import TodayShowLogo from "../images/press-logos/todayshow@2x.png";
import WSJLogo from "../images/press-logos/wsj@2x.png";

type Story = {
  img: typeof ForbesLogo;
  link: string;
  name: string;
};

const ForbesStory = {
  img: ForbesLogo,
  name: "Forbes Magazine",
  link: "https://www.forbes.com/sites/lilyjones/2020/04/03/everyones-out-of-school-how-outschool-is-making-virtual-learning-personal/#297ddd1d451f",
};
const WSJStory = {
  img: WSJLogo,
  name: "Wall Street Journal",
  link: "https://www.wsj.com/articles/with-students-stuck-at-home-parents-turn-to-online-tutoring-services-11588196846",
};
const NPRStory = {
  img: NPRLogo,
  name: "NPR",
  link: "https://www.npr.org/2020/03/13/814615866/coronavirus-and-parenting-what-you-need-to-know-now",
};
const NYTStory = {
  img: NYTLogo,
  name: "New York Times",
  link: "https://www.nytimes.com/2020/10/14/education/learning/pods-microschools-pandemic.html",
};
const FastCompanyStory = {
  img: FastCompanyLogo,
  name: "FastCompany",
  link: "https://www.fastcompany.com/90600179/education-most-innovative-companies-2021",
};
const CBSStory = {
  img: CBSLogo,
  name: "CBS",
  link: "https://www.cbsnews.com/news/help-wanted-coronavirus-and-job-prospects-for-u-s-workers/",
};
const TodayStory = {
  img: TodayShowLogo,
  name: "Today Show",
  link: "https://www.today.com/video/remote-learning-resources-for-parents-educating-kids-at-home-91677253808",
};

export const ParentStories = [
  ForbesStory,
  WSJStory,
  NPRStory,
  FastCompanyStory,
  NYTStory,
  TodayStory,
];
export const TeacherStories = [
  ForbesStory,
  WSJStory,
  NPRStory,
  FastCompanyStory,
  CBSStory,
  TodayStory,
];

type Props = {
  stories: Story[];
  trackTouch?: () => void;
};

export const InTheNews = React.forwardRef(
  ({ stories, trackTouch }: Props, ref) => {
    return (
      <Box
        flex
        ref={ref}
        sx={(theme: Theme) => ({
          [theme.breakpoints.up("md")]: {
            marginTop: "1em",
            justifyContent: "center",
          },

          overflow: "auto hidden",
          marginTop: "2em",
          justifyContent: "flext-start",
          marginBottom: "2em",
        })}
      >
        <Box
          flex
          ref={ref}
          sx={{
            flexDirection: "row",
            flexShrink: 0,

            div: {
              padding: "32px 16px 32px 16px",
            },

            "div:first-of-type": {
              paddingLeft: "32px",
            },

            "div:last-of-type": {
              paddingRight: "32px",
            },
          }}
        >
          {stories.map(story => (
            <Box key={story.name}>
              <ExternalLink url={story.link} onClick={trackTouch}>
                <Image
                  sx={{
                    objectFit: "contain",
                  }}
                  height="60px"
                  width="120px"
                  src={story.img}
                  alt={story.name}
                />
              </ExternalLink>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
);
